import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { CoachComponent } from './coach.component';
import { CoachDetailComponent } from './coach-detail/coach-detail.component';
import { CoachListComponent } from './coach-list/coach-list.component';
import { CoachRoutingModule } from './coach-routing-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { SelectSchoolModule } from 'src/shared/modules/select-school/select-school.module';
import { SelectYearLevelRelationV2Module } from 'src/shared/modules/select-year-level-relation-v2/select-year-level-relation-v2.module';
import { StatusLoadingModule } from 'src/shared/modules/status-loading/status-loading.module';
import { StatusNoDataModule } from 'src/shared/modules/status-no-data/status-no-data.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { NgxMaskPipe, NgxMaskDirective, provideNgxMask } from 'ngx-mask'


@NgModule({
  declarations: [CoachComponent, CoachDetailComponent, CoachListComponent],
  imports: [
    CommonModule,
        FeatherModule.pick(allIcons),
    CoachRoutingModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    NgxPaginationModule,
    SelectAcademicYearOnlyModule,
    SelectSchoolModule,
    SelectSchoolLevelRelationV2Module,
    MatDatepickerModule,
    SelectSchoolActivityModule,
    SelectYearLevelRelationV2Module,
    SelectSchoolProgramModule,
    SelectSchoolProgramCategoryModule,
    StatusNoDataModule,
    StatusLoadingModule,
    NgSelectModule,
    MatCardModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    PipeModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  exports: [
    CoachComponent,
  ],
  providers: [
    provideNgxMask(),
  ]
})
export class CoachModule { }
